import {
  CheckBadgeIcon,
  CheckCircleIcon,
  ClockIcon,
  TruckIcon
} from '@heroicons/react/20/solid';

import { Typography } from 'src/shared/components/ui';

const getExampleItemStageLabel = (stage?: string) => {
  if (!stage) {
    return (
      <div className="flex items-center gap-1">
        <ClockIcon className="w-4 h-4" />
        <Typography variant="body-1" className="capitalize">
          Pending
        </Typography>
      </div>
    );
  }

  const stageMap: Record<string, { icon: typeof ClockIcon; label: string }> = {
    pending: {
      icon: ClockIcon,
      label: 'Pending'
    },
    in_transit: {
      icon: TruckIcon,
      label: 'In transit'
    },
    delivered: {
      icon: CheckBadgeIcon,
      label: 'Delivered'
    },
    done: {
      icon: CheckCircleIcon,
      label: 'Done'
    }
  };

  const stageConfig = stageMap[stage.toLowerCase()] || stageMap.pending;
  const Icon = stageConfig.icon;

  return (
    <div className="flex items-center gap-1">
      <Icon className="w-4 h-4" />
      <Typography variant="body-1" className="capitalize">
        {stageConfig.label}
      </Typography>
    </div>
  );
};

export default getExampleItemStageLabel;
